
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.739 12.476"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_40265","data-name":"Group 40265","transform":"translate(-1795.5 -13753.751)"}},[_c('g',{attrs:{"id":"Group_40264","data-name":"Group 40264","stroke":"#fff","stroke-linecap":"round","stroke-width":"2"}},[_c('g',{attrs:{"id":"Group_40263","data-name":"Group 40263","transform":"rotate(-90 7787.407 5977.407)","fill":"#fff"}},[_c('path',{attrs:{"id":"Path_19875","data-name":"Path 19875","d":"M6.821 0H0","transform":"rotate(45)"}}),_c('path',{attrs:{"id":"Path_19876","data-name":"Path 19876","d":"M0 0v6.821","transform":"rotate(45 4.822 11.645)"}})]),_c('line',{attrs:{"id":"Line_1214","data-name":"Line 1214","x1":"17","transform":"translate(1796.5 13759.989)","fill":"none"}})])])])
          )
        }
      }
    